"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactInlinesvg = _interopRequireDefault(require("react-inlinesvg"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Elements = require("../Elements");

var _close = _interopRequireDefault(require("../../../../assets/icons/close.svg"));

var _plus_icon = _interopRequireDefault(require("../../../../assets/icons/plus_icon.svg"));

var Pill = function Pill(_ref) {
  var removeIcon = _ref.removeIcon,
      addIcon = _ref.addIcon,
      label = _ref.label,
      _onClick = _ref.onClick,
      primary = _ref.primary;
  return /*#__PURE__*/_react["default"].createElement(_Elements.StyledPill, {
    role: "button",
    onClick: function onClick() {
      return _onClick(label);
    },
    primary: primary
  }, addIcon ? /*#__PURE__*/_react["default"].createElement(_reactInlinesvg["default"], {
    uniquifyIDs: true,
    cacheRequests: true,
    className: "plus",
    src: _plus_icon["default"],
    onClick: function onClick() {
      return _onClick(label);
    }
  }) : null, label, removeIcon ? /*#__PURE__*/_react["default"].createElement(_reactInlinesvg["default"], {
    uniquifyIDs: true,
    cacheRequests: true,
    className: "close",
    src: _close["default"],
    onClick: function onClick() {
      return _onClick(label);
    }
  }) : null);
};

Pill.propTypes = {
  removeIcon: _propTypes["default"].bool,
  addIcon: _propTypes["default"].bool,
  primary: _propTypes["default"].bool,
  label: _propTypes["default"].string.isRequired,
  onClick: _propTypes["default"].func.isRequired
};
Pill.defaultProps = {
  addIcon: false,
  primary: false,
  removeIcon: false
};
var _default = Pill;
exports["default"] = _default;